import React from 'react';
import { useNavigate } from 'react-router-dom';
import FloatingParticles from '../components/layout/FloatingParticles';
import LoginForm from '../components/auth/LoginForm';

interface LoginPageProps {
  onLogin: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  return (
    <div className="min-h-screen bg-gray-950 bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950 text-white overflow-y-auto">
      <FloatingParticles />
      
      {/* Login Form Card - Container with padding */}
      <div className="flex items-center justify-center py-20 px-4">
        <LoginForm onLogin={onLogin} />
      </div>
    </div>
  );
};

export default LoginPage; 